import { useCallback, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { ECAMPUS_BASE_URL } from '@package/components/Blocks/Publications/constants';

const messages = defineMessages({
  ecampusDataInfo: {
    id: 'ecampus-data-info',
    defaultMessage:
      'The core data is taken from the research information system and can be edited there:',
  },
});

const FIELDS_TO_HIDE = [
  'title',
  'description',
  'acronym',
  'start',
  'end',
  'status',
  'logo',
  'isHeadOf',
  'isParticipant',
  'participatingOrgUnits',
  'partners',
];

const ECAMPUS_PROJECT_VIEW_BASE_URL = `${ECAMPUS_BASE_URL}/qisserver/a/fs.res.frontend/finance/project/view/`;

/*
  This component is mounted when users are on /add or /edit pages.
  Currently used to dynamically hide/show fields based for ResearchProject forms.
*/
const EditFormExtension = () => {
  const intl = useIntl();
  const formData = useSelector((state) => state.form?.global || false);
  const location = useSelector((state) => state.router.location);

  const isResearchProjectForm =
    (location.pathname.endsWith('/add') &&
      location.query?.type === 'ResearchProject') ||
    formData['@type'] === 'ResearchProject';

  const updateDynamicFields = useCallback(() => {
    if (isResearchProjectForm && typeof document !== 'undefined') {
      setTimeout(() => {
        FIELDS_TO_HIDE.forEach((field) => {
          const res = document.getElementsByClassName(`field-wrapper-${field}`);
          if (res.length > 0) {
            const el = res[0];
            el.style.display = formData.ecampus_id ? 'none' : 'block';
            if (el.parentElement?.classList.contains('objectlist-widget')) {
              el.parentElement.style.display = formData.ecampus_id
                ? 'none'
                : 'block';
            }

            /* hint that data is served from FIS */
            const messageId = 'ecampus-data-info';
            const messageEl = document.getElementById(messageId);
            if (formData.ecampus_id) {
              if (
                messageEl &&
                messageEl.dataset.ecampusId !== formData.ecampus_id
              ) {
                messageEl.remove();
              }
              if (!messageEl) {
                const eCampusUrl = `${ECAMPUS_PROJECT_VIEW_BASE_URL}${formData.ecampus_id}`;
                const message = document.createElement('div');
                message.id = messageId;
                message.classList.add('ui');
                message.classList.add('info');
                message.classList.add('message');
                message.classList.add('small');
                message.setAttribute('data-ecampus-id', formData.ecampus_id);
                message.innerHTML = `<span>${intl.formatMessage(
                  messages.ecampusDataInfo,
                )}</span><br/><a href="${eCampusUrl}" target="_blank">${eCampusUrl}</a>`;
                const fieldWrapper = document.getElementsByClassName(
                  'field-wrapper-ecampus_id',
                )[0];
                fieldWrapper.after(message);
              }
            } else {
              const message = document.getElementById(messageId);
              if (message) {
                message.remove();
              }
            }
          }
        });
      }, 1);
    }
  }, [isResearchProjectForm, formData]);

  useEffect(() => {
    updateDynamicFields();
  }, [updateDynamicFields]);

  useEffect(() => {
    setTimeout(() => {
      updateDynamicFields();
    }, 1000);
  }, [updateDynamicFields]);

  return <></>;
};

export default EditFormExtension;
